import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { RecordingDTO, RecordingWriteDTO } from '../interfaces/recording';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RecordingService {

  constructor(private dataService: DataService) { }

  saveRecording(recordingId: number, recording: RecordingWriteDTO): Observable<RecordingDTO> {
    if (recordingId && recordingId > 0) {
      return this.dataService.updateRecording(recordingId, recording);
    } else {
      return this.dataService.createRecording(recording);
    }
  }

  deleteRecording(recording: RecordingDTO): Observable<any> {
    if (recording && recording.id > 0) {
      return this.dataService.deleteRecording(recording.id);
    } else return of(null);
  }

  getRecording(id: number): Observable<any> {
    return this.dataService.getRecording(id);
  }

  uploadRecording(id: number, file: File ) {
    return this.dataService.uploadRecording(id, file);
  }
}
